import React from "react";
import { Box, Grid, Typography, Select, MenuItem, InputLabel, FormControl } from "@mui/material";

const DefaultTemplatesTab = () => {
  const templateOptions = ["Choose......"];
  const fields = ["Purchase Order", "Purchase Invoice", "Purchase Return", "Purchase Order Matrix", "Receiving Note", "Product Label"];

  return (
    <Box sx={{ p: 2 }}>
      <Box
        sx={{
          border: "1px solid black",
          borderRadius: "10px",
          backgroundColor: "#fff",
          p: 3,
          mt: 2,
        }}>
        {/* Header */}
        <Box
          sx={{
            borderBottom: "1px solid black",
            pb: 1,
            pl:0,
            pr:0,
            mb: 3,
            mx: -3,
          }}>
          <Typography variant="h6" sx={{ px: 3 }}>
            Purchase Document Templates
          </Typography>
        </Box>

        {/* Fields */}
        <Grid container spacing={3}>
          {fields.map((field, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
<FormControl fullWidth size="small">
  <InputLabel shrink>{field}</InputLabel>
  <Select
    displayEmpty
    value=""
    label={field}
    notched
    renderValue={(selected) => {
      if (selected === "") {
        return <span style={{ color: "#9e9e9e" }}>Choose......</span>;
      }
      return selected;
    }}
    sx={{
      backgroundColor: "#fff",
      borderRadius: "8px",
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'black',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'black',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'black',
      }
    }}
  >
    <MenuItem disabled value="">
      <em>Choose......</em>
    </MenuItem>
    {templateOptions.map((option, i) => (
      <MenuItem key={i} value={option}>
        {option}
      </MenuItem>
    ))}
  </Select>
</FormControl>

            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default DefaultTemplatesTab;
